var render = function () {
  var _vm$company, _vm$company2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    attrs: {
      "align": "end",
      "align-md": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('company-view-heading-logo', _vm._b({
    attrs: {
      "min-width": "160"
    }
  }, 'company-view-heading-logo', {
    company: _vm.company
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_vm.isLinkEnabled ? [_c('router-link', _vm._b({
    staticClass: "tit font-weight-bold",
    attrs: {
      "tag": "a"
    }
  }, 'router-link', {
    to: _vm.to
  }, false), [_vm._v(" " + _vm._s((_vm$company = _vm.company) === null || _vm$company === void 0 ? void 0 : _vm$company.name))])] : [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(_vm._s((_vm$company2 = _vm.company) === null || _vm$company2 === void 0 ? void 0 : _vm$company2.name))])]], 2), _vm.href ? _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "ma-n8",
    attrs: {
      "text": "",
      "target": "_blank",
      "color": "primary"
    }
  }, 'v-btn', {
    href: _vm.href
  }, false), [_vm._v(" 홈페이지 바로가기 "), _c('i', {
    staticClass: "icon icon-right-arrow-sm ml-4 ml-lg-8"
  })])], 1) : _vm._e(), _c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._t("actions")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }